<script setup>
import { defineAsyncComponent} from 'vue'

const props = defineProps({
	params: {
		type: Object,
		required: true,
	},
})

const IconComponent = defineAsyncComponent(()=> {
	
	let fileExtension = props.params.value.split('.').pop()

	if (['apng', 'avif', 'gif', 'jpeg', 'png', 'svg', 'webp', 'jpg'].includes(fileExtension)){
		return  import('@/icons/ImageIcon.vue')
	} else if (['m4a', 'flac', 'mp3', 'wav', 'wma', 'aac' ].includes(fileExtension)) {
		return  import('@/icons/AudioIcon.vue')
	} else if (['mp4', 'mov', 'wmv', 'avi', 'mpeg', 'ogg', 'webm', 'mpg'].includes(fileExtension)) {
		return  import('@/icons/VideoIcon.vue')
	} else if ( fileExtension === 'pdf') {
		return  import('@/icons/PDFIcon.vue')
	} else if (['doc', 'docx', 'odt', 'xls', 'ods', 'ppt', 'pptx', 'txt', 'xlsx'].includes(fileExtension)) {
		return  import('@/icons/DocumentIcon.vue')
	} else if (['7z', 'arj', 'zip', 'z', 'rar', 'pkg'].includes(fileExtension)) {
		return  import('@/icons/ZipIcon.vue')
	} else return  import('@/icons/UnknownIcon.vue')
	
})

</script>

<template>
	<span class="flex  items-center
	">
		<IconComponent  class=" shrink-0 opacity-50  mr-2 w-5 h-5" />
		<p class="text-ellipsis">{{params.value}}</p>
	</span>
</template>